import { Link } from "react-router-dom";
import { Play, Eye } from "lucide-react";
import { resolveMedia } from "../lib/api";

const formatViews = (n) => {
  if (!n) return "0";
  if (n > 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n > 1_000) return (n / 1_000).toFixed(1) + "K";
  return String(n);
};

export default function VideoCard({ video, size = "md" }) {
  const thumb = resolveMedia(video.thumbnail);
  const aspect = video.type === "short" ? "aspect-[9/16]" : "aspect-video";
  const widths = {
    sm: "w-44 sm:w-52",
    md: video.type === "short" ? "w-40 sm:w-48" : "w-72 sm:w-80",
    lg: "w-full",
  };

  return (
    <Link
      to={`/watch/${video.id}`}
      data-testid={`video-card-${video.id}`}
      className={`group flex-shrink-0 ${widths[size]} card-lift block`}
    >
      <div className={`relative ${aspect} rounded-xl overflow-hidden bg-zinc-900 border border-white/5`}>
        {thumb ? (
          <img src={thumb} alt={video.title} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-zinc-900 to-black text-zinc-700 text-xs uppercase tracking-widest">
            No thumbnail
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center bg-black/40">
          <div className="w-14 h-14 rounded-full bg-[#FF6B00] flex items-center justify-center aura-pulse">
            <Play className="w-6 h-6 text-black fill-black ml-0.5" />
          </div>
        </div>
        {video.duration ? (
          <span className="absolute bottom-2 right-2 text-[10px] font-mono bg-black/80 text-white px-1.5 py-0.5 rounded">
            {Math.floor(video.duration / 60)}:{String(Math.floor(video.duration % 60)).padStart(2, "0")}
          </span>
        ) : null}
        {video.type === "short" && (
          <span className="absolute top-2 left-2 text-[10px] font-bold uppercase tracking-widest bg-[#FF6B00] text-black px-1.5 py-0.5 rounded">
            Short
          </span>
        )}
      </div>
      <div className="mt-3 px-1">
        <h3 className="text-sm sm:text-base font-bold text-white leading-snug line-clamp-2 group-hover:text-[#FFB800] transition-colors">
          {video.title}
        </h3>
        <div className="mt-1 flex items-center gap-3 text-xs text-zinc-500">
          <span className="uppercase tracking-wider">{video.category || "general"}</span>
          <span className="inline-flex items-center gap-1"><Eye className="w-3 h-3" /> {formatViews(video.views)}</span>
        </div>
      </div>
    </Link>
  );
}
